// eslint-disable-next-line import/no-self-import, import/named
import { setParam } from '~~/common/js/universal/hash-params';

export const FILTERS_KEY = 'f';
export const IMAGE_ID_KEY = 'id';

export const getImageUrlHash = (id) => setParam(new URLSearchParams(), IMAGE_ID_KEY, id).toString();
